import { AnaColumn } from "../forms-template.service";

export const cambioPasswordForm: AnaColumn[] = [

  {
    configuration:
      {
        titleGriglia: 'Cambio Password',
        titleForm: '$cambioPasswordForm',
        breadcrumbCaption: 'Cambio Password',
        campoTitle: ['Cambio Password'],
        Service:'cambioPasswordForm',
        masterKey: 'id',
        startTemplate: 'grid',
        allowedAdvancedFilter: true,
        isAdvancedXlsExportAvailable: true,
        filterEditor: '/$',
        formType: 'simple',
        nCol: 2,
      
  
      },
  
    },
    
    {        
            itemType: "group", colCount:2, colSpan:2, class:'mt-4', data: [



              {
                  type: 'campoButton', dataField: "vecchiaPassword", colVisible: false, caption: "Password Attuale", dataType: "password",
                 mode:'password',
                 class:'customBrightness', 
                 colSpan:2, 
                 labelWidth:150,
                button: {
                  text: 'Mostra Password',
                  name: 'mostraPasswordAttuale',
                  class:'customBrightness',
                  location: 'after',
                  event: "mostraPasswordAttuale",
                  hint: "Mostra Password",
                  icon: "glyphicon mdi mdi-cryengine",
                 
                
                },
                validation: [
                  { type: "required", message: "Campo Obbligatorio" },
        
                ],
               
              },

              {
                type: 'campoButton',  colSpan:2, labelWidth:150, dataField: "nuovaPassword", colVisible: false, caption: "Password Nuova", dataType: "password",
               class:'customBrightness',
              button: {
                text: 'Mostra Password',
                name: 'mostraPasswordNuova',
                class:'customBrightness',
                location: 'after',
                event: "mostraPasswordNuova",
                mode:'password',
                hint: "Mostra Password",
                icon: "glyphicon mdi mdi-cryengine",
                outPutValue: false,
              },
              validation: [
                { type: "required", message: "Campo Obbligatorio" },
      
              ],
            },
            {
              type: 'campoButton', colSpan:2,
              labelWidth:150, dataField: "ripetiNuovaPassword", colVisible: false, caption: "Ripeti Password", dataType: "password",
            class:'customBrightness',
            button: {
              text: 'Mostra Password',
              name: 'mostraPasswordRipetuta',
              class:'customBrightness',
              location: 'after',
              event: "mostraPasswordRipetuta",
              hint: "Mostra Password",
              icon: "glyphicon mdi mdi-cryengine",
              outPutValue: false,
              },
              validation: [
                { type: "required", message: "Campo Obbligatorio" },
      
              ],
            },


            ]    
    }

]